import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { UIModule } from '@nimbus-global/features/ui/ui.module';
import { ChatMessageFormComponent } from '@nimbus-global/features/chat-form/components/chat-message-form/chat-message-form.component';
import { ChatFormControlComponent } from '@nimbus-global/features/chat-form/components/chat-form-control/chat-form-control.component';

@NgModule({
  declarations: [ChatMessageFormComponent, ChatFormControlComponent],
  imports: [CommonModule, UIModule, SharedUIModule, ReactiveFormsModule, TranslateModule],
  exports: [ChatMessageFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChatFormModule {}
